---
title: Sorting Algorithms
date: 2018-12-10T17:32:28-07:00
draft: true
---


## Selection Sort
Two loops. Outer loop goes through each item in the array. Inner loop goes through the remainder of the array, searching for the first item that’s smaller than the outer loops current index. Once the inner loop goes through all indices, then it swaps whatever was smallest and updates the outer loop

    function selectionSort(items) {
        let i,j,min,temp;
        
        for (let i = 0; i < items.length; i++){
            min = i;
            for (j = i+1; j < items.length; j++) {
                if (items[j] <  items[min]) min = j;
            }
            temp = items[i];
            items[i] = items[min];
            items[min] = temp;
        }    
    }

### Highlights
* Struggles with large lists
* Memory use is small, due to it being updated in place
* Partially sorted lists take just as long as unsorted ones
* Basically just a slower insertion sort

### Complexity
#### Time:
**Best:** *n^2*
**Worst:** *n^2*
**Average:** *n^2*
#### Space: 
**Worst:** *1*

   

## Insertion Sort
    function insertionSort(items) {
        let i,j,index;
        for (i=1; i < items.length; i++) {
            index = items[i];
            j = i;
            while ((j > 0) && (items[j-1] > index)) {
                items[j] = items[j-1];
                j = j - 1;
            }
            items[j] = index;
        }
        return items;
    }
### Highlights
* Is able to benefit from partially sorted lists
* Each insertion of an item requires every subsequent item to have to be moved forward a spot 

### Complexity
#### Time:
**Best:** *n*
**Worst:** *n^2*
**Average:** *n^2*
#### Space: 
**Worst:** *1*

   

## Bubble Sort
    function bubbleSort(items) {
        let i,j,temp;
        for (i = (items.length - 1); i >= 0; —) {
            for (j = 1; j <= i; j+++) {
                if (items[j-1] > items[j]) {
                    temp = items[j-1];
                    items[j-1] = items[j];
                    items[j] = temp;
                }
            }
        }
        return items;
    }
### Highlights
* Memory use is small, due to it being updated in place
* Is able to benefit greatly from any previous sorted sections of the list
* Very slow

### Complexity
#### Time:
**Best:** *n*
**Worst:** *n^2*
**Average:** *n^2*
#### Space: 
**Worst:** *1*
